import { Module } from 'vuex'

import { RootState } from '@/types'

import { ReferenceDataState } from './types';
import { mutations } from './mutations'
import { actions } from './actions'

export const state: ReferenceDataState = {
  countryId: undefined,
  
  countries: [],
  languages: [],
  competences: [],
  roles: [],
  titles: [],
  legalStatuses: [],
}

const namespaced: boolean = true

export const referenceData: Module<ReferenceDataState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
}